export const InquiryFrequencies = {
  PONCTUAL: 'PONCTUAL',
  MAINTENANCE: 'MAINTENANCE'
}



// WEBPACK FOOTER //
// ./src/constants/InquiryFrequencies.js